const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1000,
    xl: 1400
};

const gutters = {
    xs: 10,
    sm: 10,
    md: 12,
    lg: 14,
    xl: 20
}

const detectBreakpoint = () => {
    const viewport = window.innerWidth;
    if (viewport < breakpoints.sm) {
        return "xs"
    } else if (viewport < breakpoints.md) {
        return "sm"
    } else if (viewport < breakpoints.lg) {
        return "md"
    } else if (viewport < breakpoints.xl) {
        return "lg"
    } else {
        return "xl"
    }
};

export { breakpoints, gutters, detectBreakpoint };
